import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Panel = styled.div``;

export const GuestRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[4]} 0;
  border-bottom: 1px solid ${semantic.border.subtle};
`;

export const GuestLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const CalendarSection = styled.div`
  padding-top: ${space[4]};
`;
